import { buildQueryFromKeyValuePairs, uppercaseMarketRegion } from '../../../common/utilities';
import { getPricingApiConfig } from '../config/actions';
import { getSFCCReferralSourceCode } from '../../../sfcc/utilities/sfcc-referral-source-code-actions';
import { getSFCCRefererLink } from '../../../sfcc/utilities/sfcc-referer-link-actions';
/**
 * @internal
 */
export var getFetchSFCCPricesUrlGetByIds = function (entityIds, entityType) {
    var _a = getPricingApiConfig(), marketLocale = _a.marketLocale, baseUrl = _a.baseUrl;
    var sfccLocale = uppercaseMarketRegion(marketLocale);
    var entityTypeParameterValue = entityType === "f" /* Family */ ? 'Family' : 'Group';
    var sourceCode = getSFCCReferralSourceCode();
    var urlParamKeyValuePairs = [
        { key: 'c_method', value: "get" + entityTypeParameterValue + "Prices" },
        { key: 'q', value: "pim" + entityTypeParameterValue + "Id" },
        { key: 'c_IDs', value: entityIds.join(',') },
        { key: 'locale', value: sfccLocale },
    ];
    if (sourceCode) {
        urlParamKeyValuePairs.push({ key: 'sourceCode', value: sourceCode });
        var refererLink = getSFCCRefererLink();
        if (refererLink) {
            urlParamKeyValuePairs.push({ key: 'referer', value: refererLink });
        }
    }
    return baseUrl + "/product_search/prices?" + buildQueryFromKeyValuePairs(urlParamKeyValuePairs);
};
